import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import {
  ReadDepartmentBasedProjectRates,
  WriteDepartmentBasedProjectRates,
} from "@/schemas/departmentBasedProjectRates";

export const DepartmentBasedProjectRatesService = new APIService<
  ReadDepartmentBasedProjectRates,
  WriteDepartmentBasedProjectRates
>(API.DepartmentBasedProjectRates);
